import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import Navigation from '../components/layout/Navigation';
import Footer from '../components/layout/Footer';
import { Mail, Phone, MapPin } from 'lucide-react';

function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // Simulate sending message
    setTimeout(() => {
      toast.success('Message sent successfully!');
      setFormData({
        name: '',
        message: ''
      });
      setLoading(false);
    }, 1000);
  };

  return (
    <div className="min-h-screen flex flex-col bg-primary-50">
      <Navigation />
      <div className="flex-grow pt-20 mt-5 mb-4">
        <div className="max-w-[840px] mx-auto px-6">
          <div className="bg-primary-extra rounded-lg shadow-sm p-8 my-8">
            <div className="max-w-2xl mx-auto">
              <div className="w-full h-[450px]">
                <iframe
                  src="https://tally.so/r/3xRPNd"
                  className="w-full h-full"
                  frameBorder="0"
                  allowFullScreen
                ></iframe>
              </div>
              {/* <h1 className="text-3xl font-bold text-primary-500 mb-8 text-center">Contact Us</h1> */}

              {/* <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-primary-text mb-1">
                    Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Enter your name"
                    className="w-full rounded-md border border-primary-200 px-4 py-3 focus:border-primary-400 focus:ring-primary-400"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-primary-text mb-1">
                    Message <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="Write your message here..."
                    rows={6}
                    className="w-full rounded-md border border-primary-200 px-4 py-3 focus:border-primary-400 focus:ring-primary-400"
                    required
                  />
                </div>

                <div className="flex justify-center">
                  <button
                    type="submit"
                    disabled={loading}
                    className="px-8 py-3 bg-primary-500 text-primary-50 rounded-md hover:bg-opacity-90 transition-colors duration-200 disabled:opacity-50"
                  >
                    {loading ? 'Sending...' : 'Send Message'}
                  </button>
                </div>
              </form> */}

              {/* Enhanced Contact Information */}
              <div className="mt-16">
                {/* <h2 className="text-2xl font-semibold text-primary-500 text-center mb-8">Other Ways to Reach Us</h2> */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                  {/* Email Contact */}
                  {/* <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
                    <div className="flex flex-col items-center">
                      <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mb-4">
                        <Mail className="h-6 w-6 text-primary-500" />
                      </div>
                      <h3 className="text-lg font-medium text-primary-500 mb-2">Email Us</h3>
                      <a
                        href="mailto:contact@teacherjobs.in"
                        className="text-primary-text hover:text-primary-500 transition-colors duration-200"
                      >
                        info@findteachers.in
                      </a>
                    </div>
                  </div> */}

                  {/* Phone Contact */}
                  {/* <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
                    <div className="flex flex-col items-center">
                      <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mb-4">
                        <Phone className="h-6 w-6 text-primary-500" />
                      </div>
                      <h3 className="text-lg font-medium text-primary-500 mb-2">Call Us</h3>
                      <a href="tel:+911234567890" className="text-primary-text hover:text-primary-500 transition-colors duration-200">
                        +91 1234567890
                      </a>
                    </div>
                  </div> */}

                  {/* Office Location */}
                  {/* <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
                    <div className="flex flex-col items-center">
                      <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mb-4">
                        <MapPin className="h-6 w-6 text-primary-500" />
                      </div>
                      <h3 className="text-lg font-medium text-primary-500 mb-2">Visit Us</h3>
                      <address className="text-center text-primary-text not-italic">
                        India
                      </address>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ContactUs;